<template>
    <div>
        <div class="lke-bg">
            <div class="lke-top">
                <div class="lke-top-l">您现在所在的位置：实训平台</div>
                <div class="lke-top-r"  @click="openRouter('indexPage')">返回首页
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <div class="lke-fot">
                <div class="lke-fot-top">
                    实训平台入口
                </div>
                <div class="lke-fot-mid">
                    <p><span>提醒通知</span></p>
                    <p>学员在统一开学后，可使用账号和密码登录学习网站，从”我的课程”选择课程专题进行网上学习。
                        学员在统一开学后，可使用账号和密码登录学习网站，从”我的课程”选择课程专题进行网上学习。
                    </p>
                </div>
                <div class="lke-fot-fot">
                    <a target="_blank" href="practice.html">
                    <el-button style="padding:15px 50px;" size="medium" type="primary">进入平台</el-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

        openRouter(val){
             this.$router.push({ name: val });
        },

        open() {
            window.location.href = '/#/'
        }

    },
    components: {

    },
};
</script>

<style>
.el-button--medium{
    font-size: 20px;
    letter-spacing: 1px;
    font-weight: bold;
}
</style>

<style scoped>
.lke-top{
    width: 1024px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
}
.lke-top-l{
    font-size: 16px;
    padding-left: 20px;
}
.lke-top-r{
    font-size: 16px;
    padding-right: 20px;
    cursor: pointer;
}
.lke-top-r:hover{
    color: #2890F4;
}
.lke-fot{
    width: 944px;
    margin: 0 auto;
    padding: 0 40px;
    padding-bottom: 20px;
}
.lke-fot-top{
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    line-height: 3;
    font-family: 仿宋_GB2312;
    letter-spacing: 2px;
    color: #2890F4;
    border-top: 1px dashed #ccc;
}
.lke-fot-mid{
    color: #666666;
    padding-right: 20px;
    padding-bottom: 30px;
}
.lke-fot-mid p{
    font-size: 16px;
    line-height: 2;
    text-indent: 30px !important;
}
.lke-fot-mid span{
    line-height: 2;
    font-family: 仿宋_GB2312;
    font-size: 12pt;
    font-weight: bolder;
}
.lke-fot-fot{
    text-align: center;
    padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/sxpt/sxpt.vue